<!-- <div class="container">
    <div class="row">
        <iframe class="viewport"
            width="100%"
            frameBorder="0"
            [src]="urlSafe"></iframe>
    </div>
</div> -->
<div class="bg-image " >
<ng-container>
    <div style="margin-bottom: 50px">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="page-title-content">
                        <h2>No Data Found</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
</div>
